import React, { useEffect } from 'react'
import { EmbeddedMessageAttachment, UnfurledLinkAttachment } from '@towns-protocol/sdk'
import { useEditorSelector } from '@udecode/plate-core/react'
import { SECOND_MS } from 'data/constants'
import {
    LoadingUnfurledLinkAttachment,
    useExtractExternalLinks,
} from 'hooks/useExtractInternalLinks'
import { useExtractMessageAttachments } from 'hooks/useExtractMessageAttachments'
import { useThrottledValue } from 'hooks/useThrottledValue'

import { toPlainText } from '../utils/toPlainText'

export const CaptureLinkAttachmentsPlugin = (props: {
    onUpdate: (
        messageAttachments: EmbeddedMessageAttachment[] | undefined,
        unfurledLinkAttachments:
            | (UnfurledLinkAttachment | LoadingUnfurledLinkAttachment)[]
            | undefined,
        isLoading: boolean,
    ) => void
}) => {
    const { onUpdate } = props

    const text = useThrottledValue(
        useEditorSelector((editor) => toPlainText(editor.children), []),
        SECOND_MS * 0.5,
    )

    const { attachments: messageAttachments } = useExtractMessageAttachments(text)
    const { attachments: externalAttachments, isLoading } = useExtractExternalLinks(text)

    useEffect(() => {
        onUpdate(
            messageAttachments,
            externalAttachments
                ? // omit external urls already included as message attachments
                  externalAttachments.filter(
                      (l) =>
                          !messageAttachments || messageAttachments.every((m) => m.url !== l.url),
                  )
                : undefined,
            isLoading,
        )
    }, [externalAttachments, isLoading, messageAttachments, onUpdate])

    return <></>
}
